import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Identity } from '../identity.model';
import { IdentityService } from '../identity.service';
import { GenericResponse } from 'src/app/api-interfaces';
import { Observable, Subject } from 'rxjs';
import { FuncsService } from 'src/app/shared/funcs.service';
import { LogService } from 'src/app/shared/log.service';
import { User } from '../user.model';
import { AuthService } from 'src/app/auth/auth.service';
import { TimerService } from 'src/app/shared/timer/timer.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-revoke-identity',
  templateUrl: './revoke-identity.component.html',
  styleUrls: ['./revoke-identity.component.sass']
})
export class RevokeIdentityComponent implements OnInit {

  isSpinning: boolean;
  validateForm!: UntypedFormGroup;
  emergencyCodeVisible: boolean;
  otpCodeVisible: boolean;
  identity: Identity;
  onErcLostEventSubject: Subject<void> = new Subject<void>();
  @Input() currentUser: User;

  constructor(
    private funcs: FuncsService,
    private fb: UntypedFormBuilder,
    private identityService: IdentityService,
    private logger: LogService,
    private authService: AuthService,
    public timerService: TimerService
  ) { }

  ngOnInit(): void {
    this.validateForm = this.fb.group({
      emergencyCode: [null, [Validators.required]],
      otpCode: [null, [Validators.required]]
    });
    this.identity = this.identityService.getCurrentIdentity();
    this.identityService.currentIdentityChanged.subscribe((data: Identity) => {
      this.identity = data;
    })
  }

  submitForm() {

    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }

    this.isSpinning = true;

    this.identityService.revokeIdentity(
      this.identity.pk,
      this.validateForm.value["emergencyCode"],
      this.validateForm.value["otpCode"]
    )
      .subscribe(
        (response: GenericResponse) => {
          if (response["esito"] == "OK") {
            this.logger.log("Response OK");
            this.validateForm.reset();
            if (environment.resetTimerWhenSubmit) {
              this.timerService.resetTimerSendOTP();
            }
            this.authService.requestUpdatedUserObservable()
              .subscribe(
                (response: GenericResponse) => {
                  let user: User = response["result"]
                  this.logger.log(user);
                  this.authService.setCurrentUser(user);
                }
              );
            this.identityService.setCurrentView('personalData');
          }
        },
        (err: Observable<never>) => { this.isSpinning = false; },
        () => { this.isSpinning = false; },
      );
  }

  getValidationErrorMessage(errors: any): string {
    return this.funcs.getValidationErrorMessage(errors);
  }

  onErcLost() {
    this.onErcLostEventSubject.next();
  }

  activateSpin(value: boolean) {
    this.isSpinning = value;
  }
}
